import { ColumnApi, GridApi } from 'ag-grid-community';
import { XpoAgGridBoardApi } from '../ag-grid-board-api/index';

export class XpoAgGridBoardReadyEvent {
  agGridApi: GridApi;
  agGridColumnApi: ColumnApi;
  agGridBoardApi: XpoAgGridBoardApi;
}
